require('object-fit-polyfill');
require('respimg-polyfill');
require('bgset');
const lazysizes = require('lazysizes');
const delegate = require('delegate');
import { str2json } from '../utilities';

export default {
  init: function(app) {
    this.app = app;

    delegate(
      document.body,
      '[data-action]',
      'click',
      (e) => {
        e.preventDefault();
        const evData = str2json(e.delegateTarget.dataset.action);
        this.app.emit(evData.type, { identifier: evData.target });
      },
      false
    );
  }
};
